import { useState } from "react";
import { toast } from "sonner";
import { Camera } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, imgSrc } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { RoleSelect } from "@/pages/Onboarding";
import { TierBadge, VerifiedBadge } from "@/components/MemberBits";

export default function MyProfile() {
  const { user, setUser, refresh } = useAuth();
  const [f, setF] = useState({ name: user.name, bio: user.bio, city: user.city, country: user.country, gender: user.gender, role_type: user.role_type });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await api.put("/me", f); setUser(data); toast.success("Profile saved"); } catch (err) { toast.error(errMsg(err)); }
  };
  const upload = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post("/me/photo", fd); await refresh(); toast.success("Photo updated"); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <main className="mx-auto grid max-w-5xl gap-12 px-5 py-14 md:grid-cols-[280px_1fr]" data-testid="my-profile-page">
      <div>
        <label className="group relative block cursor-pointer overflow-hidden" data-testid="profile-photo-upload">
          <img src={imgSrc(user.photo)} alt="" className="aspect-[3/4] w-full object-cover" />
          <div className="absolute inset-0 flex items-center justify-center bg-black/60 opacity-0 transition-opacity group-hover:opacity-100"><Camera className="h-8 w-8" /></div>
          <input data-testid="profile-photo-input" type="file" accept="image/*" className="hidden" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} />
        </label>
        <div className="mt-4 flex gap-2"><TierBadge tier={user.membership} /><VerifiedBadge status={user.id_status} /></div>
      </div>
      <form onSubmit={save} className="space-y-5" data-testid="profile-form">
        <h1 className="font-display text-5xl">My profile</h1>
        <RoleSelect value={f.role_type} onChange={(v) => setF({ ...f, role_type: v })} />
        <Input data-testid="profile-name-input" value={f.name} onChange={set("name")} placeholder="Display name" className="h-12 bg-zinc-900" />
        <div className="grid grid-cols-2 gap-4">
          <Input data-testid="profile-city-input" value={f.city} onChange={set("city")} placeholder="City" className="h-12 bg-zinc-900" />
          <Input data-testid="profile-country-input" value={f.country} onChange={set("country")} placeholder="Country" className="h-12 bg-zinc-900" />
        </div>
        <Input data-testid="profile-gender-input" value={f.gender} onChange={set("gender")} placeholder="Gender" className="h-12 bg-zinc-900" />
        <Textarea data-testid="profile-bio-input" rows={5} value={f.bio} onChange={set("bio")} placeholder="Tell members about yourself…" className="bg-zinc-900" />
        <button data-testid="profile-save-btn" className="btn-red rounded-full px-10 py-3 font-semibold">Save</button>
      </form>
    </main>
  );
}
